
import React from "react";
import { Magnetic } from "../ui/magnetic";

const SOCIAL_LINKS = [
  {
    label: 'Youtube',
    link: 'https://www.youtube.com/@Yousha_Syed',
  },
  {
    label: 'Twitter',
    link: 'https://x.com/yousha_syed',
  },
  {
    label: 'Instagram',
    link: 'https://instagram.com/yousha_syed',
  },
  {
    label: 'Substack',
    link: 'https://syedyousha.substack.com/',
  }
];

function MagneticSocialLink({ children, link }) {
  return (
    <Magnetic springOptions={{ bounce: 0 }} intensity={0.3}>
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="group relative inline-flex shrink-0 items-center gap-[1px] rounded-full border border-slate-300/80 bg-white/90 px-3 py-1.5 text-sm text-slate-800 shadow-[0_5px_12px_rgba(15,23,42,0.08)] transition-all duration-200 hover:-translate-y-0.5 hover:bg-slate-900 hover:text-white dark:border-slate-600/80 dark:bg-slate-800 dark:text-zinc-100 dark:hover:bg-slate-700"
      >
        {children}
        <svg
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="h-3 w-3"
        >
          <path
            d="M3.64645 11.3536C3.45118 11.1583 3.45118 10.8417 3.64645 10.6465L10.2929 4L6 4C5.72386 4 5.5 3.77614 5.5 3.5C5.5 3.22386 5.72386 3 6 3L11.5 3C11.6326 3 11.7598 3.05268 11.8536 3.14645C11.9473 3.24022 12 3.36739 12 3.5L12 9.00001C12 9.27615 11.7761 9.50001 11.5 9.50001C11.2239 9.50001 11 9.27615 11 9.00001V4.70711L4.35355 11.3536C4.15829 11.5488 3.84171 11.5488 3.64645 11.3536Z"
            fill="currentColor"
            fillRule="evenodd"
            clipRule="evenodd"
          ></path>
        </svg>
      </a>
    </Magnetic>
  );
}

function Sponsorship() {
  return (
    <div className="text-center mt-10 space-y-8 w-full">
      <div className="border border-border/80 rounded-2xl p-6 mx-2 shadow-[0_12px_30px_rgba(15,23,42,0.08)] bg-card/85 backdrop-blur-sm">
        <div className="flex flex-col items-center gap-4">
          <p className="text-sm sm:text-base text-center leading-relaxed max-w-md">
            Salam, thank you for playing! I hope you enjoy and share with a
            friend! :)
          </p>
        </div>
      </div>

      {/* Google AdSense Ad Unit */}
      <div className="flex justify-center">
        <ins
          className="adsbygoogle"
          style={{ display: "block" }}
          data-ad-client="ca-pub-1387348082718063"
          data-ad-slot="YOUR_AD_SLOT_ID"
          data-ad-format="auto"
          data-full-width-responsive="true"
        ></ins>
        <script>(adsbygoogle = window.adsbygoogle || []).push({});</script>
      </div>
    </div>
  );
}

export function SponsorshipLinks() {
  return (
    <div className="w-full">
      <div className="flex flex-wrap items-center justify-center gap-3 mt-4 mb-2">
        {SOCIAL_LINKS.map((link) => (
          <MagneticSocialLink key={link.label} link={link.link}>
            {link.label}
          </MagneticSocialLink>
        ))}
      </div>
    </div>
  );
}

export default Sponsorship;
